

export default function AdminHeader({ setApp, isHome, setIsHome, logout }) {
    const backAdminHome = () => {
        setApp('default')
        setIsHome(true)
    }
    const backToFai = () => {
        window.location.href = '/'
    }

    return <>
        <header className="w-full bg-slate-600 p-5">
            <nav className="flex justify-between">
                {isHome ? <button onClick={() => backToFai() }> Voltar ao Site </button> : <button onClick={() => backAdminHome() }> Voltar </button>}
                <button onClick={() => logout() }> Encerrar Sessão </button>
            </nav>
        </header>
    </>
}